import { Card, Flex, Typography } from 'antd';
import classes from './SelectCard.module.scss';
import { DownOutlined } from '@ant-design/icons';
import React from 'react';
import { CardInfoT } from 'common/types/cards';
import { getLinearGradientString } from '../../../common/lib/utils/helpers';
import { MAIN_GRADIENT } from '../../lib/constants/colors';
import { Card as CardComponent } from '../../../common/components/UI';

const { Text } = Typography;

type SelectCardProps = {
  currentOption: CardInfoT;
  className?: string;
}

const Index: React.FC<SelectCardProps> = ({ currentOption, className }) => (
  <Card className={`${classes['card']}${className ? ' ' + classes[className] : ''}`}>
    <Flex justify="space-between" align="center">
      <Flex vertical gap={4}>
        <Text className={classes['card__subtitle']}>
          Weststein | {currentOption?.cardNumber}
        </Text>
        <Text className={classes['card__amount']}>
          {currentOption?.availBal ? currentOption?.availBal.toFixed(2) : '0.00'} €
        </Text>
      </Flex>
      <Flex gap={16} align="center">
        <CardComponent
          size="s"
          shortNumber={currentOption?.cardNumber.slice(-4) || ''}
          bgColor={getLinearGradientString(MAIN_GRADIENT)}
        />
        <DownOutlined style={{
          color: '#00000099',
          fontSize: 16,
        }} />
      </Flex>
    </Flex>
  </Card>
);

export default Index;